import "./App.css";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n";
import Seo from "./Seo";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustAuthority from "./components/TrustAuthority";
import Services from "./components/Services";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";
import Moments from "./components/Moments";
import Guides from "./components/Guides";
import FAQ from "./components/FAQ";
import LeadForm from "./components/LeadForm";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import ExitIntent from "./components/ExitIntent";

function App() {
  return (
    <I18nProvider>
      <Seo />
      <div className="App relative min-h-screen bg-[#050507] text-white overflow-x-hidden" data-testid="app-root">
        <Navbar />
        <main>
          <Hero />
          <TrustAuthority />
          <Services />
          <HowItWorks />
          <Testimonials />
          <Moments />
          <Guides />
          <FAQ />
          <LeadForm />
          <FinalCTA />
        </main>
        <Footer />
        <FloatingButtons />
        <ExitIntent />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#0A0A0C",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#fff",
            },
          }}
        />
      </div>
    </I18nProvider>
  );
}

export default App;
